import { axios } from '../../../axios';

const getSavedPropertiesApi = () => {
  return axios.get('/users/fav')
}

export { getSavedPropertiesApi }